export default __webpack_public_path__ + "static/media/EM1060.34I-27025_-16405_0.c88f34ed.jpg";